import { getResource } from "./request";

const endpoint = "proposer/GetProposers";

export async function getAllProposers(data: proposerFormType) {
  const { response, error, code } = await getResource({ endpoint, data });

  return { response, error, code };
}

export async function getSingleProposer(data: SingleProposerFormType) {
  const { response, error, code } = await getResource({
    endpoint: "proposer/GetProposer",
    data,
  });

  return { response, error, code };
}

export interface proposerFormType {
  fund_id?: number[] | "All";
  num_per_page: number;
  page_number: number;
  challenge_id?: number | number[] | "All";
  proposer_name?: string;
  order_by?: string;
  ordering?: "asc" | "desc";
  funded_status?: string;
}

export interface proposerCardSummaryType {
  number_of_rows: number;
  items: proposerCardType[];
}

export interface proposerCardType {
  user_id: number;
  user_name: string;
  ranking?: number;
  quick_stats_data: proposerQuickStatType;
}

export interface proposerQuickStatType {
  number_of_proposals: number;
  average_rating: number;
  amount_requested: number;
  funded_amount: number;
  funded_proposals: number;
  highest_proposal_rating: number;
  highest_amount_requested: number;
  total_result_votes: number;
  total_up_votes: number;
  total_down_votes: number;
  conversion_percentage: number;
  funding_percentage: number;
}

export interface SingleProposerFormType {
  user_id: number;
}

export interface SingleProposerInfoType {
  user_id: number;
  user_name: string;
  quick_stats_data: SingleProposerStatsType;
}

export interface SingleProposerStatsType {
  number_of_proposals: number;
  average_rating: number;
  amount_requested: number;
  funded_amount: number;
  funded_proposals: number;
  highest_proposal_rating: number;
  highest_amount_requested: number;
  total_result_votes: number;
  total_up_votes: number;
  total_down_votes: number;
  conversion_percentage: number;
  funding_percentage: number;
}
